/* Документы листа шаблона (#stPre) про запас. У шаблона лист собирается из своих данных и выезжает уже заполненным (openPre, bot-studio.js);
   у сервера документ приходит по сети, поэтому загрузка начинается раньше нажатия — на касании карточки (pointerdown), и один ответ служит
   и касанию, и нажатию, и повторному открытию. Хранится недолго; смена аккаунта (steos:account-updated) сбрасывает всё. */
import { studioApi } from './studio-api';
import { studioPreview, type StudioPreviewModel } from './studio-preview-model';

const TTL_MS = 5 * 60_000;
interface Entry {
  at: number;
  promise: Promise<StudioPreviewModel>;
  value?: StudioPreviewModel;
  failed?: boolean;
}
const store = new Map<number, Entry>();

if (typeof document !== 'undefined') document.addEventListener('steos:account-updated', () => store.clear());

const fresh = (entry: Entry | undefined): entry is Entry => !!entry && !entry.failed && Date.now() - entry.at < TTL_MS;

/** Документ листа: из запаса или запросом (общим для всех, кто ждёт этот шаблон) */
export function loadStudioPreview(id: number): Promise<StudioPreviewModel> {
  const hit = store.get(id);
  if (fresh(hit)) return hit.promise;
  const entry = { at: Date.now() } as Entry;
  entry.promise = studioApi
    .app(id)
    .then(document => (entry.value = studioPreview(document, id)))
    .catch(failure => {
      entry.failed = true;
      throw failure;
    });
  /* ошибку читает тот, кто откроет лист; сама загрузка про запас её не показывает */
  entry.promise.catch(() => {});
  store.set(id, entry);
  return entry.promise;
}

/** Уже загруженный документ — лист сразу открывается заполненным */
export function cachedStudioPreview(id: number): StudioPreviewModel | null {
  const hit = store.get(id);
  return fresh(hit) ? (hit.value ?? null) : null;
}

/** Начать загрузку заранее (касание карточки шаблона) */
export function prefetchStudioPreview(id: number) {
  if (Number.isSafeInteger(id) && id > 0) void loadStudioPreview(id).catch(() => {});
}

/** Для тестов */
export function clearStudioPreviews() {
  store.clear();
}
